import { Card, Icon, IconType } from "@kolmeo/ui-components";
import { Box, Text, toTitleCase, useTheme } from "@kolmeo/ui-core";
import { useMediaQuery } from "@src/hooks";
import { useBranding } from "@src/navigation/useBranding";

interface PaymentMethodCardType {
  onPress: () => void;
  text: "string";
  icon: IconType;
}
const CardButton = ({ onPress, text: string, icon }: PaymentMethodCardType) => {
  const { palette, spacing, colors } = useTheme();
  const { brandingObject } = useBranding();
  const { isBelowTablet } = useMediaQuery();

  return (
    <Card
      flexDirection={"row"}
      marginBottom={5}
      marginHorizontal={1}
      marginVertical={20}
      onPress={() => onPress()}
      paddingVertical={12}
      flex={1}
      maxWidth={isBelowTablet ? "100%" : "17%"}
      forceRemoveShadow
      backgroundColor={brandingObject?.primaryColor || colors.primary}
    >
      <Box flexDirection={"row"} alignItems={"center"} flexWrap={"wrap"}>
        <Box paddingRight={spacing.px8}>{icon && <Icon type={icon} size={"sm"} color={"#fff"} />}</Box>
        <Text color={"#fff"} variant="buttonHeavy14">
          {toTitleCase(string)}
        </Text>
      </Box>
    </Card>
  );
};

export default CardButton;
